module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- build-targets/portal/packages/core-app/src/templates/confirmView.html -->\n<div class="container">\n	<div class="container-fluid">\n		<p>'+
((__t=( message.format( itemLabel ) ))==null?'':__t)+
'</p>\n	</div>\n\n	<footer>\n		';
 var doubleClass = (noLabel && yesLabel) ? ' double' :  ' single'; 
__p+='\n		<div class="actions'+
((__t=( doubleClass ))==null?'':__t)+
'">\n			';
 if (noLabel) { 
__p+='\n			<button type="button" class="btn btn-default cancel nx-cancel nx-cancel" data-nx-control="no"><span class="text">'+
((__t=( noLabel ))==null?'':__t)+
'</span></button>\n			';
 } 
__p+='\n			';
 if (yesLabel) { 
__p+='\n			<button type="submit" class="btn btn-primary submit nx-save" data-nx-control="yes"><span class="text">'+
((__t=( yesLabel ))==null?'':__t)+
'</span></button>\n			';
 } 
__p+='\n		</div>\n	</footer>\n</div>\n';
}
return __p;
};
